import { render, staticRenderFns } from "./device-add.vue?vue&type=template&id=4ae7d3f5&"
import script from "./device-add.vue?vue&type=script&lang=js&"
export * from "./device-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae7d3f5')) {
      api.createRecord('4ae7d3f5', component.options)
    } else {
      api.reload('4ae7d3f5', component.options)
    }
    module.hot.accept("./device-add.vue?vue&type=template&id=4ae7d3f5&", function () {
      api.rerender('4ae7d3f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/device-list/device-add.vue"
export default component.exports